export default __webpack_public_path__ + "static/media/logo_Ministerio-de-Salud.1fc4f8b8.png";